<template>
  <MainContent>
    <b-row>
      <b-col cols="3" />
      <b-col cols="6">
        <LoginCpsForm class="p-4 border" />
      </b-col>
      <b-col cols="3" />
    </b-row>
  </MainContent>
</template>

<script>
import MainContent from "../../../components/main/MainContent";
import LoginWelcomBanner from "../components/login/LoginWelcomBanner";
import LoginCpsForm from "../components/login-cps/LoginCpsForm";
import InfoNewsTable from "@/components/info/InfoNewsTable";
import { UserApi } from "nx-libs";
import { EshApi } from "@/api";

export default {
  components: {
    LoginWelcomBanner,
    LoginCpsForm,
    InfoNewsTable,
    MainContent
  },
  async beforeRouteEnter(to, from, next) {
    const enableEpsLoginPage = (await EshApi.getRegistrationPublicSystemSetting()).EnableEpsLoginPage;
    if (!enableEpsLoginPage) {
      next({ name: "Login" }); // redirect to login page for ESS
    } else {
      next();
    }
  },
  async created() {
    try {
      await UserApi.getCurrentUser();
      window.location.href = process.env.VUE_APP_CPS_URL;
    } catch (e) {}
  }
};
</script>

<style lang="scss" scoped>
.right-panel {
  background-color: #ffffff;
  padding: 2rem;
}
</style>

<i18n>
{
  "en": {
    "complaint": "Complaint / Report"
  },
  "zh_hk": {
    "complaint": "投訴 / 舉報"
  },
  "zh_cn": {
    "complaint": "投诉 / 举报"
  }
}
</i18n>
